'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const TrophyIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.0039 18V15M18.25 4.75H21.25V7.25C21.25 8.90685 19.9069 10.25 18.25 10.25M5.75 4.75H2.75V7.25C2.75 8.90685 4.09315 10.25 5.75 10.25M5.75 2.75H18.25V9.25C18.25 12.5637 15.5637 15.25 12.25 15.25H11.75C8.43629 15.25 5.75 12.5637 5.75 9.25V2.75ZM17.25 21.25V18.75C17.25 18.1977 16.8023 17.75 16.25 17.75H7.75C7.19772 17.75 6.75 18.1977 6.75 18.75V21.25H17.25Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpTrophyIcon = forwardRef(TrophyIcon);

export { VpTrophyIcon as default };
